import { SVGProps } from 'react'

/**
 * Outline SVG icons used by redesigned input/selector primitives
 * (SearchInput, SearchableSelect, DateField, ClientSelector, etc.).
 * They render at 1em × 1em by default and use `currentColor` so the
 * containing `IconSlot` controls both color and size.
 */

const baseProps = {
  width: '1em',
  height: '1em',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
} as const

export const SearchOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps} strokeWidth={1.8} {...props}>
    <circle cx='11' cy='11' r='7' />
    <line x1='21' y1='21' x2='16.65' y2='16.65' />
  </svg>
)

export const CalendarOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps} strokeWidth={1.8} {...props}>
    <rect x='3' y='5' width='18' height='16' rx='2' />
    <line x1='3' y1='10' x2='21' y2='10' />
    <line x1='8' y1='3' x2='8' y2='7' />
    <line x1='16' y1='3' x2='16' y2='7' />
  </svg>
)

export const UserOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps} strokeWidth={1.8} {...props}>
    <circle cx='12' cy='8' r='4' />
    <path d='M4 21c0-4.418 3.582-8 8-8s8 3.582 8 8' />
  </svg>
)

export const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps} strokeWidth={2} {...props}>
    <polyline points='6 9 12 15 18 9' />
  </svg>
)
